<template>
  <!-- <swiper :options="swiperOption">
    <swiper-slide v-for="(banner, index) in sliders" :key="index">
      <a :href="banner.link" target="_blank" style="width: 200px">
        <v-img :src="banner.image"></v-img>
      </a>
    </swiper-slide>
  </swiper> -->

  <v-carousel hide-delimiters height="100%">
    <v-carousel-item v-for="(banner, i) in sliders" :key="i">
      <!-- <v-img :src="banner.image" tile></v-img> -->
      <a :href="banner.link" target="_blank" class="w-100 h-100">
        <div class="slider-item" :style="{ backgroundImage: `url(${banner.image})` }"></div>
      </a>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
// import { swiper, swiperSlide } from "vue-awesome-swiper";
import { AuthService } from "@/services"
export default {
  // components: { swiper, swiperSlide },

  data() {
    return {
      swiperOption: {
        direction: "horizontal",
        slidesPerView: 1,
        slidesPerGroup: 2,
        spaceBetween: 16,
        setWrapperSize: 380,
        autoplay: {
          delay: 4000
        },
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          // when window width is >= 600px
          600: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          800: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          // when window width is >= 960px
          960: {
            slidesPerView: 3,
            spaceBetween: 16
          },
          1025: {
            slidesPerView: 3,
            spaceBetween: 16
          }
        },
        lazy: true,
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        //   disabledClass: "custom"
        // },
        pagination: {
          el: ".banner-slider-pagination",
          clickable: true
        }
      },
      sliders: []
    }
  },
  methods: {
    getSliders() {
      AuthService.getRegisterSliders().then((response) => {
        this.sliders = response.data.data
      })
    }
  },
  mounted() {
    this.getSliders()
  },
}
</script>

<style lang="scss" scoped>
.slider-item {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 20px !important;
  overflow: hidden;
}
</style>